import Args from "./Args";
import {Mixins} from "../Mixins";
import AlacakKalem from "./AlacakKalem";
import TarafKisi from "./TarafKisi";
import TarafKurum from "./TarafKurum";

export default class Ilam {
    ilamBilgileri: {
        yargiTuru: string,
        yargiBirimi: string,
        dosyaYil: string,
        dosyaSira: string,
        ilamTuru: string,
    } = {
        yargiTuru: "",
        yargiBirimi: "",
        dosyaYil: "",
        dosyaSira: "",
        ilamTuru: ""
    }
    id!: number;//id;
    ilamTuru: any;//ilamTuru;
    ilamTuruText: string = ''//ilamTuruText;
    birimId: any;//birimId;
    birimAdi: string = ''//birimAdi;//Ankara 24. Asliye Hukuk Mahkemesi;
    /** Yalnızca form tarafında mahkeme listesini geri yüklemek için tutulur, UYAP'a gönderilmez. */
    adliyeId: string = ''
    /** İlamı veren mahkemenin ili. Takibin ilinden farklı olabilir; UYAP'a gönderilmez. */
    il: string = ''
    // UYAP dosya türü listesinde value SAYI; XML'den metin geldiği için parse'ta sayıya çevrilir.
    dosyaTurKod: string | number = ''//dosyaTurKod;//15;
    dosyaTurKodText: string = ''//dosyaTurKodText;//Hukuk Dava Dosyası;
    dosyaNo: string = ''//dosyaNo;//2017/309;
    dosyaYil: string = ''//dosyaYil;//2017;
    dosyaSira: string = ''//dosyaSira;//309;
    yevmiyeYil: string = ''//yevmiyeYil;//;
    yevmiyeSira: string = ''//yevmiyeSira;//;
    ilamliKurumAdi: string = ''//ilamliKurumAdi;//;
    ilamliAciklama: string = ''//ilamliAciklama;//Ankara 24. Asliye Hukuk Mahkemesi'nin 2017/309 E.; 2018/68 K. s.lı ilamı gereğince 5000 TL vekalet ücretinin tahsili istemidir.;
    kararDosyaYil: string = ''//kararDosyaYil;//;
    kararDosyaSira: string = ''//kararDosyaSira;//;
    ilamTarihi: string = ''//ilamTarihi;//;
    ilamliParaylaOlculemeyenAlacak: string = ''//ilamliParaylaOlculemeyenAlacak;//;
    alacakKalemleri: AlacakKalem[] = []//alacakKalemleri;

    /**
     * XML öznitelikleri metin taşır, UYAP dosya türü listesinde ise value sayı.
     * Vuetify'ın deepEqual'ı tip duyarlı olduğu için "15" ile 15 eşleşmiyor ve Dosya Türü
     * kutusu dolu bir kayıtta bile boş görünüyordu. Sayısal olmayan değer bozulmadan kalır.
     */
    private static dosyaTurKoduNormalize(deger: any): string | number {
        const metin = Mixins.nullUndefCleaner(deger);
        const sayi = Number(metin);
        return (metin === "" || Number.isNaN(sayi)) ? metin : sayi;
    }

    static fromJson(jsonData: any): Ilam {
        let obj = Args.staticFromJson(jsonData,new Ilam());
        obj.alacakKalemleri = jsonData.alacakKalemleri.map((x: AlacakKalem) => AlacakKalem.fromJson(x));
        // Düzeltme öncesi kuyruğa girmiş kayıtlarda dosyaTurKod metin olarak saklandı.
        obj.dosyaTurKod = Ilam.dosyaTurKoduNormalize(obj.dosyaTurKod);
        return obj;
    }

    static parse(ilamNode: HTMLUnknownElement,
                 args: Args,
                 tarafList: Array<TarafKisi | TarafKurum>): Ilam {
        args.setIlamli();
        let ilamliParaylaOlculemeyenAlacak = "";
        let paraylaOlculemeyenAlacaklar = ilamNode.querySelectorAll("takipSekliIlamliParaylaOlculemeyen");
        paraylaOlculemeyenAlacaklar.forEach((paraylaOlculemeyenAlacak, key) => {
            if (key > 0)
                ilamliParaylaOlculemeyenAlacak += ",";
            ilamliParaylaOlculemeyenAlacak += paraylaOlculemeyenAlacak.getAttribute("aciklama");
        });
        let ilam = new Ilam();

        ilam.id = args.ilamCounterId();
        ilam.ilamTuru = Mixins.nullUndefCleaner(ilamNode.getAttribute('ilamkurumtip'));
        ilam.ilamTuruText = ilam.getIlamKurumTurleri().find(x => x.value == ilam.ilamTuru)?.name || '';
        ilam.birimId = Mixins.nullUndefCleaner(ilamNode.getAttribute('birimid'));
        ilam.birimAdi = Mixins.nullUndefCleaner(ilamNode.getAttribute('birimadi'));
        // UYAP mahkeme listesini il -> adliye -> yargı birimi zinciriyle yüklüyor; bu ikisi
        // olmadan liste hiç dolmadığı için dolu gelen birimId de eşleşemiyordu (DEV-2829).
        ilam.il = Mixins.nullUndefCleaner(ilamNode.getAttribute('ilkodu'));
        ilam.adliyeId = Mixins.nullUndefCleaner(ilamNode.getAttribute('orgkodu'));
        // UYAP'a giden istek zaten Number(ilam.dosyaTurKod) yapıyor; sayıya çevirmek
        // gönderilen değeri değiştirmez, yalnızca form eşleşmesini düzeltir.
        ilam.dosyaTurKod = Ilam.dosyaTurKoduNormalize(ilamNode.getAttribute('dosyaturkod'));
        ilam.dosyaTurKodText = Mixins.nullUndefCleaner(ilamNode.getAttribute('dosyaturkodtext'));

        ilam.dosyaYil = Mixins.nullUndefCleaner(ilamNode.getAttribute('ilamdosyanoyil'));
        ilam.dosyaSira = Mixins.nullUndefCleaner(ilamNode.getAttribute('ilamdosyasira'));
        ilam.kararDosyaYil = Mixins.nullUndefCleaner(ilamNode.getAttribute('ilamkararnoyil'));
        ilam.kararDosyaSira = Mixins.nullUndefCleaner(ilamNode.getAttribute('ilamkararsira'));

        ilam.dosyaNo = ilam.dosyaYil.toString() + '/' + ilam.dosyaSira.toString();
        ilam.ilamliKurumAdi = Mixins.nullUndefCleaner(ilamNode.getAttribute('ilamkurumad'));
        ilam.ilamliAciklama = Mixins.nullUndefCleaner(ilamNode.getAttribute('ilamaciklama'));
        ilam.ilamTarihi = Mixins.nullUndefCleaner(ilamNode.getAttribute('ilamtarihi'));
        ilam.ilamliParaylaOlculemeyenAlacak = ilamliParaylaOlculemeyenAlacak;

        ilam.ilamBilgileri.yargiTuru = Mixins.nullUndefCleaner(ilamNode.getAttribute('yargiBirimiId'));
        ilam.ilamBilgileri.yargiBirimi = Mixins.nullUndefCleaner(ilamNode.getAttribute('yargiBirimi'));
        ilam.ilamBilgileri.dosyaYil = Mixins.nullUndefCleaner(ilamNode.getAttribute('ilamDosyaNoYil'));
        ilam.ilamBilgileri.dosyaSira = Mixins.nullUndefCleaner(ilamNode.getAttribute('ilamDosyaSira'));
        ilam.ilamBilgileri.ilamTuru = Mixins.nullUndefCleaner(ilamNode.getAttribute('ilamKurumTip'));

        // UYAP birimi bilinmiyorsa tür "Diğer"e düşürülür. Değer string olmalı (MDB seçenek
        // değerleri string; number verilirse İlam Türü kutusu boş görünüyordu) ve ilamBilgileri
        // kopyası da güncellenmeli, aksi halde sorgu mantığı hâlâ eski türü görüyordu.
        if (ilam.birimId == "") {
            ilam.ilamTuru = "6";
            ilam.ilamBilgileri.ilamTuru = "6";
            ilam.ilamTuruText = "Diğer";
            ilam.birimAdi = "";
            ilam.il = "";
            ilam.adliyeId = "";
            ilam.dosyaTurKod = "";
            ilam.dosyaTurKodText = "";
        }

        let altinciMadde = Mixins.nullUndefCleaner(ilamNode.getAttribute("altinciMadde"));
        if (altinciMadde)
            ilam.ilamliAciklama = altinciMadde;

        ilam.alacakKalemleri = AlacakKalem.getAlacakKalemListFromDom(ilamNode, args, tarafList);
        return ilam;
    }

    getIlamKurumTurleri() {
        return [
            {name: 'Hukuk Mahkemesi', value: 0},
            {name: 'Ceza Mahkemesi', value: 1},
            {name: 'İdare Mahkemesi', value: 2},
            {name: 'Noter', value: 3},
            {name: 'Hakem Kararı', value: 4},
            {name: 'Arabuluculuk', value: 5},
            {name: 'Diğer', value: 6},
            {name: 'Bölge Adliye Mahkemeleri', value: 7}
        ]
    }

    toUyapJson() {
        let {
            birimAdi, birimId, dosyaNo, dosyaSira, dosyaTurKod, dosyaTurKodText, dosyaYil, id,
            ilamliAciklama, ilamliKurumAdi, ilamliParaylaOlculemeyenAlacak,
            ilamTarihi, ilamTuru, ilamTuruText, kararDosyaSira, kararDosyaYil, yevmiyeSira, yevmiyeYil
        } = this;
        console.log("alacakKalemleri", this.alacakKalemleri);
        return {
            alacakKalemleri: this.alacakKalemleri.map(i => i.toUyapJson()),
            birimAdi,
            birimId,
            dosyaNo,
            dosyaSira,
            dosyaTurKod,
            dosyaTurKodText,
            dosyaYil,
            id,
            ilamliAciklama,
            ilamliKurumAdi,
            ilamliParaylaOlculemeyenAlacak,
            ilamTarihi,
            ilamTuru,
            ilamTuruText,
            kararDosyaSira,
            kararDosyaYil,
            yevmiyeSira,
            yevmiyeYil
        };
    }
}

